<script setup>
defineProps({
  item: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <a :href="item.url"
     class=" p-5 rounded-lg bg-white hover:bg-gray-100 transition-colors duration-150 ease-in-out shadow-md group gap-2">
    <h2 class="w-fit group-hover:underline text-indigo-700 ">{{ item.name }}</h2>
    <span class="text-sm text-gray-400"> {{ __(':counter Articles', { counter: item.counter }) }}</span>
  </a>
</template>
